import { c as _c } from "react/compiler-runtime";
import { useConnection, useWallet } from "@solana/wallet-adapter-react";
import { PublicKey, TransactionInstruction, TransactionMessage, VersionedTransaction } from "@solana/web3.js";
import { useCallback } from "react";
import { parseSvmTransactionError, TransactionRevertedError } from "../lib/errors";
export const useSvmTransact = () => {
  const $ = _c(5);
  const {
    connection
  } = useConnection();
  const {
    wallet
  } = useWallet();
  let t0;
  if ($[0] !== connection || $[1] !== wallet) {
    t0 = async t1 => {
      const {
        instructions,
        addressLookupTableAddresses
      } = t1;
      if (!wallet?.adapter.publicKey) {
        throw new Error("Wallet not connected");
      }
      ;
      try {
        const {
          context: t3,
          value: t4
        } = await connection.getLatestBlockhashAndContext();
        const {
          slot: minContextSlot
        } = t3;
        const {
          blockhash,
          lastValidBlockHeight
        } = t4;
        const transactionInstructions = instructions.map(_temp2);
        const addressLookupTableAccounts = await Promise.all(addressLookupTableAddresses.map(address => connection.getAddressLookupTable(new PublicKey(address)).then(_temp3)));
        const message = new TransactionMessage({
          payerKey: wallet.adapter.publicKey,
          recentBlockhash: blockhash,
          instructions: transactionInstructions
        });
        const transaction = new VersionedTransaction(message.compileToV0Message(addressLookupTableAccounts));
        const signature = await wallet.adapter.sendTransaction(transaction, connection, {
          minContextSlot
        });
        const wait = async () => {
          ;
          try {
            const receipt = await connection.confirmTransaction({
              blockhash,
              lastValidBlockHeight,
              signature
            });
            if (receipt.value.err === null) {
              return {
                status: "success",
                hash: signature
              };
            }
            const error_1 = Error(svmErrorToString(receipt.value.err));
            return {
              status: "failed",
              hash: signature,
              error: new TransactionRevertedError(error_1)
            };
          } catch (t5) {
            const error_0 = t5;
            return {
              status: "failed",
              hash: signature,
              error: parseSvmTransactionError(error_0)
            };
          }
        };
        return {
          hash: signature,
          wait
        };
      } catch (t2) {
        const error = t2;
        throw parseSvmTransactionError(error);
      }
    };
    $[0] = connection;
    $[1] = wallet;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const transact = t0;
  let t1;
  if ($[3] !== transact) {
    t1 = {
      transact
    };
    $[3] = transact;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
function svmErrorToString(err) {
  if (typeof err === "string") {
    return err;
  }
  if (typeof err === "object") {
    try {
      return JSON.stringify(err);
    } catch {
      return String(err);
    }
  }
  return String(err);
}
function _temp(key) {
  return {
    pubkey: new PublicKey(key.pubkey),
    isSigner: key.isSigner,
    isWritable: key.isWritable
  };
}
function _temp2(instruction) {
  return new TransactionInstruction({
    keys: instruction.keys.map(_temp),
    programId: new PublicKey(instruction.programId),
    data: instruction.data ? Buffer.from(instruction.data, "hex") : undefined
  });
}
function _temp3(res) {
  return res.value;
}